<template>
    <div class="order-menu-empty-area">
        <div class="order-menu-empty-note">
            如果视频有遮挡请点击 “异常订单” 按钮
            <br>
            <br>
            如果视频无遮挡并且视频中没有任何购物行为，请点击下面的按钮
        </div>
        <div
            v-on:click="confirm"
            class="order-menu-confirm-button">
            用户什么都没拿
        </div>
    </div>
</template>

<script>
 import EventBus from "../event/event-bus.js"

 export default {
     name: 'EmptyOrderList',
     props: {
     },
     components: {
     },
     methods: {
         confirm() {
             console.log("OrderList confirmOrder emit")
             
             EventBus.$emit("confirmOrder")
         }
     }
 }
</script>

<style scoped>
 .order-menu-empty-area {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;

     width: 300px;
     height: 200px;
 }

 .order-menu-empty-note {
     color: #666666;
     flex: 1;
     margin-left: 20px;
     margin-right: 20px;
     margin-top: 50px;
     margin-bottom: 50px;
 }

 .order-menu-confirm-button {
     width: 140px;
     color: #FFFFFF;
     font-size: 16px;
     background-color: #5DC55C;
     border-radius: 5px;
     padding-left: 10px;
     padding-right: 10px;
     padding-top: 4px;
     padding-bottom: 4px;
     margin-left: 5px;
     margin-right: 10px;
     margin-bottom: 20px;
     text-align: center;
     user-select: none;
 }
</style>
